import React, { PropTypes } from 'react';
import StarRating from 'common/components/star_rating';
import { MAX_SELECTED_REVISIONS } from 'presentations/constants';

const VotePreview = ({ logo, primaryColor }) => {
  return (
    <div className="participant-preview vote-preview">
      <header style={{ backgroundColor: primaryColor }}>
        <i className="fa fa-close pull-right" />
        { logo &&
        <div className="logo" style={{ backgroundImage: `url(${logo})` }} /> }
        <div className="text-center">
          <div className="controls">
            <span className="left-control">
              <i className="fa fa-angle-left" /> Previous
            </span>
            <strong>5 of { MAX_SELECTED_REVISIONS }</strong>
            <span className="right-control">
              Next <i className="fa fa-angle-right" />
            </span>
          </div>
          <StarRating readonly={true} />
        </div>
      </header>
      <div className="main-content">
        <div style={{ backgroundImage: "url('https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_categories_hero-1_stache-wax.png')" }} className="sample-logo" />
        <div className="image-controls text-center">
          <i className="fa fa-arrows-alt" />
          <i className="fa fa-search-plus" />
          <i className="fa fa-search-minus" />
        </div>
      </div>
    </div>
  );
}

VotePreview.propTypes = {
  logo: PropTypes.string,
  primaryColor: PropTypes.string
};

export default VotePreview;



// WEBPACK FOOTER //
// ./presentations/components/vote_preview.jsx